import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useOrdersModuleApi } from "../../common/useOrdersModuleApi";
import { OrderListingContext } from "../listing/context/OrderListingContext";
import { OrderListingItem } from "../listing/OrderListingItem";

type DeleteOrderDialogProps = {
    item: OrderListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const DeleteOrderDialog: React.VFC<DeleteOrderDialogProps> = ({
    isOpen,
    item,
    onClose
}: DeleteOrderDialogProps) => {
    const { deleteOrder } = useOrdersModuleApi();
    const { success } = useNotifications();
    const { deleteOrder: deleteOrderItem } = useContext(OrderListingContext);

    const handleDelete = async () => {
        await deleteOrder({ orderId: item.id });
        deleteOrderItem(item.id);

        success("Order deleted");

        onClose();
    };

    return (
        <ConfirmDialog
            title="Delete order"
            text="Are you sure you want to delete this order? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: handleDelete }}
            cancel={{ onClick: onClose }}
        />
    );
};
